import { combineReducers } from 'redux';
import { connectRouter } from 'connected-react-router';
import project from './project';
import buyerMap from './buyerMap';
import strategyMap from './strategyMap';
import charts from './charts';
import auth from './auth';
import nonCustomers from './nonCustomers';
import errc from './errc';
import toBeStrategyMap from './toBeStrategyMap';

export default (history) => combineReducers({
    router: connectRouter(history),
    project,
    buyerMap,
    strategyMap,
    charts,
    nonCustomers,
    auth,
    errc,
    toBeStrategyMap
});
